import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FacilityDataService } from '../../data-services/facility.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';

@Component({
   selector: 'facility-add',
   templateUrl: './facility.add.html',
   styleUrls: ['./facility.add.css'],
   imports: [FormsModule]
})
export class FacilityAddComponent implements OnInit {
   @Output() operationComplete = new EventEmitter<string>();

   constructor(private facilityDataService: FacilityDataService,
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig) {
   }

   searchFacility: string = '';
   searchResults:any [] = [];
   loading: boolean;
   selected: any;

   ngOnInit() {
      this.loading = true;

      this.loading = false;
   }

   public doSearch() {
      if (!this.canSearch()) {
         return;
      }

      this.searchResults = [];

         this.facilityDataService.searchFacilities(this.searchFacility).subscribe((data: any) => {
            Array.prototype.push.apply(this.searchResults, data);
         });

   }

  selectResult(facility) {
    console.log('facility: ' + JSON.stringify(facility));
     this.selected = facility; // this.searchResults[ind];
      this.ref.close(this.selected);
   }

   canSearch() {
     return true;
   }
}
